<template>
  <!-- eslint-disable max-len -->
  <div class="modal-parent">
    <div
      v-shortkey="['esc']"
      class="modal"
      @shortkey="closeModal"
    >
      <div class="modal_topbar">
        <div class="modal_topbar-title">
          Wellness Declaration Settings
        </div>
        <div class="modal_topbar_actions">
          <template v-if="loading">
            <loader :size="25" />
          </template>
          <span
            id="exit-survey-modal"
            class="modal_topbar-exit"
            @click="closeModal"
            v-html="closeIcon"
          />
        </div>
      </div>
      <div class="modal_topbar__description mb-1">
        State the criteria that your end users must meet in order to gain access. All answers must
        be checked in order for a user to be admitted. (e.g. I have NOT come into contact with
        anyone diagnosed with COVID, as opposed to, I have come into contact with anyone diagnosed
        with COVID.)
      </div>
      <div class="modal-content">
        <template v-for="(question, index) in questions">
          <div
            :key="index"
            class="survey-question-container"
          >
            <textarea
              :id="'question-textarea-' + index"
              v-model="questions[index]"
              class="form-field"
              maxlength="500"
            >
            </textarea>
            <span
              v-show="questions.length > 1"
              :id="'remove-question-' + index"
              class="survey__icon-button survey__icon-button--remove ml-1"
              @click="removeQuestion(index)"
              v-html="removeIcon"
            />
          </div>
        </template>
        <div
          v-show="questions.length < 10"
          class="survey__button-label"
        >
          <span
            id="add-question"
            class="survey__icon-button"
            @click="addQuestion"
            v-html="addIcon"
          />
          <label>Add Question</label>
        </div>
      </div>
      <div class="modal_footer">
        <button
          id="default-questions-button"
          class="btn btn--grey"
          @click="setDefaultQuestions()"
        >
          Default Questions
        </button>
        <div class="modal_footer--right">
          <button
            id="cancel-survey-button"
            class="btn btn--grey mr-1"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            id="save-survey-button"
            class="btn"
            @click="saveSurvey()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <div class="modal-overlay" />
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
import feather from 'feather-icons'

export default {
  name: 'ConfigureSurveyModal',
  props: ['loading', 'survey', 'defaultQuestions'],
  data() {
    return {
      questions: [],
      closeIcon: feather.icons.x.toSvg(),
      addIcon: feather.icons['plus-circle'].toSvg(),
      removeIcon: feather.icons['minus-circle'].toSvg(),
    }
  },
  created() {
    if (this.survey.questions) {
      this.questions = this.deepCopy(this.survey.questions)
    } else {
      this.setDefaultQuestions()
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    addQuestion() {
      const _questionNumber = this.questions.length + 1
      this.questions.push(`Question ${_questionNumber}`)
    },
    removeQuestion(index) {
      this.questions.splice(index, 1)
    },
    saveSurvey() {
      const _surveyPayload = {
        bcidSettings: {
          wellnessSurvey: {
            uuid: this.survey.uuid,
            questions: this.questions,
          },
        },
      }
      this.$emit('save', _surveyPayload)
    },
    setDefaultQuestions() {
      this.questions = this.deepCopy(this.defaultQuestions)
    },
  },
}
</script>

<style lang="scss" scoped>
.survey {
  &-question-container {
    @include flex-display();
    @include flex-align-items(center);
  }
  &__icon-button {
    @include transition(transform 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6));
    color: $blue;
    &--remove {
      color: $grey-text;
    }
    &:hover {
      @include transform(scale(1.1));
      cursor: pointer;
    }
  }
  &__button-label {
    @include flex-display();
    @include flex-align-items(center);
    margin-top: 1em;
    label {
      margin-left: 0.5em;
    }
  }
}
</style>
